// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Reveal-module__reveal___DJfWj {\n    opacity: 0;\n    transform: translateY(28px);\n    transition:\n        opacity 0.7s ease-out,\n        transform 0.7s ease-out;\n}\n\n.Reveal-module__revealVisible___G62NR {\n    opacity: 1;\n    transform: translateY(0);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reveal": "Reveal-module__reveal___DJfWj",
	"revealVisible": "Reveal-module__revealVisible___G62NR"
};
export default ___CSS_LOADER_EXPORT___;
